<template>
    <div data-qa="rename-cell-modal" class="konva-rename-cell-modal">
        <DsModal
            center
            show-close
            size="sm"
            :is-open="isOpen"
            :title="modalTitle"
            @close="closeModal"
        >
            <template #header>
                <DsFilledButton
                    data-qa="save-button"
                    :disabled="actionDisabled"
                    @click="updateConfig"
                >
                    {{ $t('goal.setting.save') }}
                </DsFilledButton>
            </template>

            <DsInputField
                v-if="showRename"
                v-model="cellName"
                data-qa="cell-rename-input"
                class="cell-setting-input"
                :label="$t('global.name')"
            />
            <section
                v-if="showSettings"
                data-qa="cell-settings-input"
                class="goal-type"
            >
                <span class="goal-type-label"> {{ $t('funnel.edit.sequence.settings.label') }} </span>
                <DsRadio
                    v-model="global"
                    :disabled="globalButtonDisabled"
                    :val="$options.GOAL_ACHIEVEMENT_TYPE.GLOBAL"
                    required
                >
                    <span :class="{ disabled: globalButtonDisabled }">{{ $t('funnel.edit.sequence.settings.global') }}</span>
                </DsRadio>
                <DsRadio
                    v-model="global"
                    :disabled="notGlobalButtonDisabled"
                    class="not-global-option"
                    :val="$options.GOAL_ACHIEVEMENT_TYPE.NOT_GLOBAL"
                    required
                >
                    <span :class="{ disabled: notGlobalButtonDisabled }">{{ $t('funnel.edit.sequence.settings.not.global') }}</span>
                </DsRadio>
            </section>
        </DsModal>
    </div>
</template>

<script>
import { canConfigureCellSettings } from '../utils/cell/automation-cell-utils';
import { GOAL_ACHIEVEMENT_TYPE } from '../utils/editor.constants';

export default {
    GOAL_ACHIEVEMENT_TYPE,
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        showRename: {
            type: Boolean,
            default: false,
        },
        showSettings: {
            type: Boolean,
            default: false,
        },
        allCells: {
            type: Array,
            required: true,
        },
        cell: {
            type: Object,
            required: true,
        },
    },
    emits: ['close-cell-settings-modal', 'update-cell-name'],
    data() {
        return {
            cellName: this.cell.value?.name || this.cell.text,
            global: this.cell.value?.global || GOAL_ACHIEVEMENT_TYPE.GLOBAL,
            configurationEnabled: canConfigureCellSettings(this.cell, this.allCells),
        };
    },

    computed: {
        globalButtonDisabled() {
            return !this.configurationEnabled && this.global !== GOAL_ACHIEVEMENT_TYPE.GLOBAL;
        },

        notGlobalButtonDisabled() {
            return !this.configurationEnabled && this.global !== GOAL_ACHIEVEMENT_TYPE.NOT_GLOBAL;
        },

        actionDisabled() {
            return !this.cellName;
        },

        modalTitle() {
            return this.showSettings
                ? this.$t('funnel.edit.sequence.settings.title')
                : this.$t('funnel.edit.sequence.rename.title');
        },
    },
    methods: {
        closeModal() {
            this.$emit('close-cell-settings-modal');
        },

        updateConfig() {
            const cellValue = { ...this.cell.value, name: this.cellName };

            if (this.showSettings) {
                cellValue.global = this.global;
            }

            this.$emit('update-cell-name', { cell: { ...this.cell, value: cellValue } });
            this.closeModal();
        },
    },
};
</script>
<style lang="scss" scoped>
.disabled {
    color: $color-gray-400;
}
.cell-setting-input {
    margin-bottom: 0;
}
.goal-type {
    margin-top: $spacing-300;
}
.goal-type-label {
    font-size: $font-size-md;
    font-weight: 400;
    line-height: $line-height-md;
}
.not-global-option {
    padding-top: 0;
}
</style>
